import IMask from 'imask'

// TODO:
// Does this belong here? should this be moved to mixins?
function unmaskFormValues(data, fields) {
  let unmaskedData = { ...data }

  for (let field of fields) {
    if ('mask' in field) {
      const fieldValue = data[field.name]
      const options = field.mask
      const maskOptions = typeof options === 'object' && options.mask ? options : { mask: options }

      const masked = IMask.createMask(maskOptions)
      if (fieldValue === '' || fieldValue === undefined) {
        unmaskedData[field.name] = fieldValue
        continue
      }

      if ([Number, Date].includes(maskOptions.mask)) {
        masked.typedValue = data[field.name]
      } else {
        masked.value = data[field.name]
      }

      unmaskedData[field.name] = masked.unmaskedValue
    }
  }

  return unmaskedData
}

export default unmaskFormValues
